import Swiper from 'swiper'
Swiper.use([])

export function teamInit(){
  let slider

  $('.slider--team').each(function(){
    slider = new Swiper(this, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: true,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 36,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 36,
        },
      },
    })
  })

  if($('.team__filter')){
    let firstFilter = $('.team__filter').first().attr('data-filter') || ''
    if(firstFilter){
      setFilter(firstFilter)
      updateItems(firstFilter)
    }
    
    $('.team__filter').on('click', function(e){
      e.preventDefault()
      let filter = $(this).attr('data-filter') || ''
      
      setFilter(filter)
      updateItems(filter)
    })
  }

  function setFilter(filter) {
    $('.team__filter[data-filter]').removeClass('active')
    $('.team__filter[data-filter=' + filter + ']').addClass('active')
  }

  function updateItems(filter){
    if(filter){
      $('[data-teams]').each(function(i, item){
        let match = $(item).data('teams')
          .split(', ')
          .find(function(item){
            return item == filter
          })
        if(match){
          $(item).parent('.swiper-slide').show()
        }else{
          $(item).parent('.swiper-slide').hide()
        }
      })
    }

    if(slider){
      slider.updateSize()
      slider.updateSlides()
      slider.updateProgress()
      slider.updateSlidesClasses()
      slider.slideTo(0)
    }
  }
}
